import { atom } from "jotai";

export const categorieName = atom("");
